import { emphasize } from "@material-ui/core/styles/colorManipulator";
import { fade } from "@material-ui/core/styles/colorManipulator";

export const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(2),
  },
  style: {
    display: "none",
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  body: {
    fontSize: "14px",
    fontWeight: "400",
    padding: 0,
  },
  icon: {
    fontSize: 40,
    float: "right",
    cursor: "pointer",
  },
  iconWrap: {
    fontSize: 40,
    float: "right",
    cursor: "pointer",
    padding: "4px",
  },
  title: {
    display: "inline-block",
    fontSize: 34,
    fontWeight: 500,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.8)",
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    display: "flex",
    // backgroundColor: '#eaeaea'
  },
  searchIcon: {
    width: theme.spacing(9),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  inputInput: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(10),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 120,
      "&:focus": {
        width: 200,
      },
    },
  },
  frameTitle: {
    display: "flex",
    justifyContent: "space-between",
  },
});

export const selectSupportStyles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    display: "inline-block",
    padding: "6px 0 7px",
  },
  input: {
    display: "flex",
    padding: 0,
  },
  valueContainer: {
    display: "flex",
    flexWrap: "wrap",
    flex: 1,
    alignItems: "center",
  },
  chip: {
    margin: `${theme.spacing(0.5)}px ${theme.spacing(0.25)}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
      0.08
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: "absolute",
    left: 2,
    fontSize: 16,
  },
  paper: {
    marginTop: theme.spacing(1),
  },
  divider: {
    height: theme.spacing(2),
  },
  label: {
    fontWeight: 410,
  },
});

export const menu = (theme) => ({
  dropdownIcon: {
    marginLeft: theme.spacing(2),
  },
  menu: {
    minWidth: 200,
  },
});
